import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Eye, Edit, UserCog, Trash2, Search, Car } from 'lucide-react';

const VehiclesTabContent = ({
  vehicles, customers, jobs, vehicleSearchQuery, vehicleSearchResults,
  can, user, onSearch, onViewHistory, onEdit, onTransfer, onDelete
}) => {
  const displayVehicles = vehicleSearchResults !== null ? vehicleSearchResults : vehicles;
  const isAdmin = user?.isAdmin || user?.role === 'admin';

  return (
    <>
      <div className="mb-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input placeholder="Plaka, marka, model veya musteri ara..." value={vehicleSearchQuery}
            onChange={e => onSearch(e.target.value)}
            className="bg-gray-800 border-gray-700 text-white pl-10 h-9 text-sm" data-testid="vehicle-search" />
        </div>
      </div>
      <div className="space-y-2">
        {displayVehicles.length === 0 ? (
          <div className="text-center text-gray-400 py-6">{vehicleSearchResults !== null ? 'Arama sonucu bulunamadi' : 'Kayitli arac yok'}</div>
        ) : (
          displayVehicles.map(v => {
            const cust = customers.find(c => c.id === v.customerId);
            const vJobs = jobs.filter(j => j.carPlate === v.plate || j.vehicleId === v.id);
            return (
              <Card key={v.id} className="bg-gray-800/60 border-gray-700/40" data-testid={`vehicle-card-${v.id}`}>
                <CardContent className="p-3 flex justify-between items-center">
                  <div className="flex-1 min-w-0">
                    <p className="text-brand font-bold text-sm">{v.plate}</p>
                    <p className="text-gray-300 text-xs">
                      {[v.brand, v.model, v.color].filter(Boolean).join(' ') || v.details}
                      {(cust || v.customerName) ? ` - ${cust?.name || v.customerName}` : ''}
                    </p>
                    <p className="text-gray-500 text-xs">{vJobs.length} is kaydi{v.notes ? ` | ${v.notes}` : ''}</p>
                  </div>
                  <div className="flex gap-1 flex-shrink-0">
                    <Button size="sm" variant="outline" className="border-gray-600 text-gray-300 text-xs h-7"
                      onClick={() => onViewHistory(v.id)} data-testid={`vehicle-history-${v.id}`}>
                      <Eye className="h-3 w-3 mr-1" />Gecmis
                    </Button>
                    {(can('can_edit_vehicle') || isAdmin) && (
                      <Button size="sm" variant="outline" className="border-blue-700 text-blue-400 text-xs h-7"
                        onClick={() => onEdit(v)} data-testid={`vehicle-edit-${v.id}`}>
                        <Edit className="h-3 w-3" />
                      </Button>
                    )}
                    {(can('can_transfer_vehicle') || isAdmin) && (
                      <Button size="sm" variant="outline" className="border-yellow-700 text-yellow-400 text-xs h-7"
                        onClick={() => onTransfer(v)} data-testid={`vehicle-transfer-${v.id}`}>
                        <UserCog className="h-3 w-3" />
                      </Button>
                    )}
                    {(can('can_delete_vehicle') || isAdmin) && (
                      <Button size="sm" variant="destructive" className="text-xs h-7"
                        onClick={() => onDelete(v.id, v.plate)} data-testid={`vehicle-delete-${v.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })
        )}
      </div>
    </>
  );
};

export default VehiclesTabContent;
